'use client';

import { __awaiter, __generator } from '../../_virtual/_tslib.js';

var SUCCESS_CODE = 200;
var API_GET_JOB_INVITATION_NOTIFICATION = 'api-gateway/v1.0/profile/job-invitation/notification';
var getJobInvitationNotifications = function (params) { return __awaiter(void 0, void 0, void 0, function () {
    var msBaseUrl, langCode, _a, accessToken, url, response, responseData, ex_1;
    return __generator(this, function (_b) {
        switch (_b.label) {
            case 0:
                _b.trys.push([0, 3, , 4]);
                msBaseUrl = params.msBaseUrl, langCode = params.langCode, _a = params.accessToken, accessToken = _a === void 0 ? '' : _a;
                if (accessToken === '') {
                    return [2 /*return*/, null];
                }
                url = "".concat(msBaseUrl, "/").concat(API_GET_JOB_INVITATION_NOTIFICATION, "?limit=10");
                return [4 /*yield*/, fetch(url, {
                        method: 'GET',
                        headers: {
                            'Accept-Language': langCode,
                            Authorization: "Bearer ".concat(accessToken),
                            'Content-Type': 'application/json'
                        }
                    })];
            case 1:
                response = _b.sent();
                if (!response) {
                    return [2 /*return*/, null];
                }
                return [4 /*yield*/, response.json()];
            case 2:
                responseData = _b.sent();
                if (responseData.status === SUCCESS_CODE) {
                    return [2 /*return*/, responseData.data];
                }
                return [2 /*return*/, null];
            case 3:
                ex_1 = _b.sent();
                console.error(ex_1);
                return [2 /*return*/, null];
            case 4: return [2 /*return*/];
        }
    });
}); };
var updateReadJobInvitationNotification = function (params) { return __awaiter(void 0, void 0, void 0, function () {
    var msBaseUrl, langCode, _a, accessToken, jobInvitationId, response, ex_2;
    return __generator(this, function (_b) {
        switch (_b.label) {
            case 0:
                _b.trys.push([0, 3, , 4]);
                msBaseUrl = params.msBaseUrl, langCode = params.langCode, _a = params.accessToken, accessToken = _a === void 0 ? '' : _a, jobInvitationId = params.jobInvitationId;
                if (accessToken === '') {
                    return [2 /*return*/, null];
                }
                return [4 /*yield*/, fetch("".concat(msBaseUrl, "/").concat(API_GET_JOB_INVITATION_NOTIFICATION), {
                        method: 'PUT',
                        headers: {
                            'Accept-Language': langCode,
                            Authorization: "Bearer ".concat(accessToken),
                            'Content-Type': 'application/json'
                        },
                        body: JSON.stringify({
                            jobInvitationId: jobInvitationId
                        })
                    })];
            case 1:
                response = _b.sent();
                if (!response) {
                    return [2 /*return*/, null];
                }
                return [4 /*yield*/, response.json()];
            case 2: return [2 /*return*/, _b.sent()];
            case 3:
                ex_2 = _b.sent();
                console.error(ex_2);
                return [3 /*break*/, 4];
            case 4: return [2 /*return*/];
        }
    });
}); };

export { getJobInvitationNotifications, updateReadJobInvitationNotification };
//# sourceMappingURL=jobInvitation.js.map
